import { createContext, useContext } from 'react';

const WorkspaceWindowContext = createContext(null);

export function WorkspaceWindowProvider({ windowId, children, ...api }) {
  return (
    <WorkspaceWindowContext.Provider value={{ windowId, ...api }}>
      {children}
    </WorkspaceWindowContext.Provider>
  );
}

export function useWorkspaceWindow() {
  return useContext(WorkspaceWindowContext);
}